<template>
  <div class="big-box">
    <img :src="backgroundImage" alt="" class="big-box-img" />
    <div class="big-body">
      <img :src="tapTopUrl" alt="" class="tap-top" />
      <div class="pd8">
        <!-- 主题文字 -->
        <div
          class="theme-word"
          :style="`color: ${customerPaperwork.textColor};`"
        >
          <span>{{ customerPaperwork.activityTheme }}</span>
          <span>{{ customerPaperwork.activityRemark }}</span>
        </div>
        <div class="lockAuth-step">
          <div class="lockAuth-step_item">
            <div class="step-num">step.1</div>
            <div class="step-desc">
              在{{ ruleForm.lockStartTime }}-{{ ruleForm.lockEndTime }}
            </div>
            <div class="step-desc">
              <span>花费</span>
              <span
                class="special-tip"
                :style="{
                  color: customerPaperwork.processColor || templateObj.rgb,
                }"
                >{{
                  ruleForm.lockType == 0
                    ? ruleForm.point
                    : 0
                }}</span
              >
              <span>{{ ruleForm.lockType == 0 ? "积分" : "元" }}锁权</span>
            </div>
          </div>
          <div class="lockAuth-step_item">
            <div class="step-num">step.2</div>
            <div class="step-desc">
              在{{ ruleForm.orderStartTime }}-{{ ruleForm.orderEndTime }}
            </div>
            <div class="step-desc">
              <div v-if="ruleForm.orderStateType == 0">
                <span>下单付款并</span>
                <span
                  class="special-tip"
                  :style="{
                    color: customerPaperwork.processColor || templateObj.rgb,
                  }"
                  >确认收货</span
                >
              </div>
              <div v-else>
                <span>下单并</span>
                <span
                  class="special-tip"
                  :style="{
                    color: customerPaperwork.processColor || templateObj.rgb,
                  }"
                  >付款</span
                >
              </div>
            </div>
            <div class="step-desc">
              {{ ruleForm.orderCountType == 0 ? "累计" : "单笔" }}购买满{{
                ruleForm.orderStartPayment
              }}元
            </div>
          </div>
          <div class="lockAuth-step_item">
            <div class="step-num">step.3</div>
            <div class="step-desc">
              在{{ ruleForm.prizeStartTime }}-{{ ruleForm.prizeEndTime }}
            </div>
            <div
              class="step-desc special-tip"
              :style="{
                color: customerPaperwork.processColor || templateObj.rgb,
              }"
            >
              领取奖品
            </div>
          </div>
        </div>
        <!-- 底部奖品栏目 -->
        <div class="bottomDom">
          <div
            class="btnDom"
            :style="`background-image: url(${btnUrl});color: ${customerPaperwork.btnColor || templateObj.rgb3};`"
          >
            <span>X积分锁权</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "",
  components: {},
  mixins: [],
  props: {
    ruleForm: {
      type: Object,
      default: () => ({}),
    },
    customerPaperwork: {
      type: Object,
      default: () => ({}),
    },
    templateObj: {
      type: Object,
      default: () => ({}),
    },
    backgroundImage: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      prizeList: [],
      tapTopUrl:"https://cdn-image.yucrm.cn/images/dyAssets/images/preview/shop_top.png"
    };
  },
  computed: {
    btnUrl() {
      return this.customerPaperwork.btnUrl
        ? this.customerPaperwork.btnUrl
        : this.templateObj.url3;
    },
    venderType() {
      return this.ruleForm.venderType == 0;
    },
  },
  watch: {
  },
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.big-box {
  position: relative;
  width: 300px;
  height: 580px;
  box-shadow: 0px 4px 20px 0px rgba(18, 10, 60, 0.15);
  border-radius: 24px;
  border: 1px solid #ffffff;
  padding: 8px;
  margin-left: 231px;
  z-index: 999;
  background-color: #ffffff;
  .big-box-img {
    border-radius: 24px;
    width: 284px;
    height: 564px;
  }
  .big-body {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: hidden;
    .pd8 {
      width: 100%;
      height: 100%;
      padding: 8px;
      box-sizing: border-box;
      position: relative;
      .tap-top {
        width: 100%;
      }
      .theme-word {
        position: absolute;
        display: flex;
        flex-direction: column;
        align-items: center;
        top: 21px;
        width: 100%;
        > span:first-child {
          font-weight: bold;
          font-size: 18px;
          margin-bottom: 10px;
        }
        > span:last-child {
          font-size: 10px;
        }
      }
      .lockAuth-step {
        position: absolute;
        top: 360px;
        left: 0;
        width: 100%;
        display: flex;
        padding: 10px;
        &_item {
          flex: 1;
          .step-num {
            display: flex;
            flex-direction: column;
            align-items: center;
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 8px;
            color: #999999;
            line-height: 8px;
            text-align: center;
            font-style: normal;
            text-transform: none;
            margin-bottom: 5px;
          }
          .step-desc {
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 8px;
            color: #333333;
            line-height: 8px;
            text-align: center;
            font-style: normal;
            text-transform: none;
          }
          .special-tip {
            color: #DC0003;
          }
        }
      }
      .bottomDom {
        position: absolute;
        top: 440px;
        left: 50%;
        transform: translateX(-50%);
        .btnDom {
          margin: 0 auto;
          width: 182px;
          height: 37px;
          background-size: 100% 100%;
          background-position: center;
          background-repeat: no-repeat;
          font-weight: bold;
          font-size: 12px;
          text-align: center;
          line-height: 37px;
          cursor: pointer;
          background-size: cover;
        }
      }
    }
  }
  .title {
    margin-top: 20px;
    font-size: 14px;
    font-weight: 400;
    color: #999999;
    line-height: 14px;
    text-align: center;
  }
}
@font-face {
  font-family: "pingfangshaohua";
  src: url("../../../../../assets/font/pingfangshaohua.woff2") format("woff2");
  font-weight: normal;
  font-style: normal;
}
</style>
